(function ($) {
  'use strict';

  // Variáveis
  const $form = $('#form-login');
  const $btnSubmit = $('#entrar');
  const $formCadastroInputs = $('.form-login-init');
  const $formTit = $('.pag-login-title');
  const $campoEmail = $form.find('#login');
  const $verifyCodeWrp = $('.verification-code-wrp');
  const $resendTxt = $('.mdl-resend-txt');
  const $resendLink = $('.mdl-resend-link');
  const $validateBtn = $('.mdl-btn');
  const urlVerifica = urlBase + 'core/acoes/app/acesso/verificacao_login.php';
  let btnSubmitTxt = $btnSubmit.html();
  let formTitTxt = $formTit.html();
  let sending = false;
  let resendTimer;
  let resendSeconds = 60;
  let resendCountdown = resendSeconds;

  if ($form.length) {
    // Envia o formulário
    $form.on('submit', function (ev) {
      ev.preventDefault();
      submitFormInitial();
    });

    // Fix para os campos com validação remota
    $form.find('[data-parsley-remote]').each(function () {
      $(this)
        .parsley()
        .on('field:validate', function () {
          if (!sending) {
            $btnSubmit.prop('disabled', true);
          }
        })
        .on('field:validated', function () {
          if (!sending) {
            $btnSubmit.prop('disabled', false);
          }
        });
    });
    $btnSubmit.on('click', function (ev) {
      ev.preventDefault();
      $form
        .parsley()
        .whenValidate()
        .done(function () {
          submitFormInitial();
        });
    });

    // Ao clicar para solicitar um novo código
    $resendLink.on('click', 'a', function (ev) {
      ev.preventDefault();
      sendVerification();
    });

    // Ao clicar no botão para validar o código
    $validateBtn.on('click', function (ev) {
      ev.preventDefault();
      validateCode();
    });

    // Envia o formulário inicial para validação de e-mail
    function submitFormInitial() {
      registerLogin();
    }

    // Exibe a confirmação de e-mail
    function showVerification() {
      $formCadastroInputs.hide();
      $formTit.text('Verificação de login');

      $verifyCodeWrp.removeClass('d-none');
    }

    // Oculta a confirmação de e-mail
    function hideVerification() {
      $verifyCodeWrp.addClass('d-none');
      $formCadastroInputs.show();
      $formTit.text(formTitTxt);
      if (resendTimer) {
        clearInterval(resendTimer);
        resendCountdown = resendSeconds;
      }
    }

    // Envia o código de verificação
    function sendVerification() {
      if (sending) {
        return false;
      }
      let email = $campoEmail.val().trim();
      const data = {
        acao: 'verifica_email',
        email: email,
      };
      $('.v-mail').text(email);
      $resendTxt.find('b').text(resendSeconds);
      $resendLink.hide();
      $resendTxt.show();
      showLoader();
      sending = true;
      $.getJSON(urlVerifica, data, function (result) {
        console.log(result);
        sending = false;
        hideLoader();
        if (result && result.status === 'success') {
          $('.verification-code input').val('');
          showVerification();
          setTimeout(() => {
            $('.verification-code input').first().focus();
          }, 100);
          resendTimer = setInterval(() => {
            resendCountdown--;
            $resendTxt.find('b').text(resendCountdown);
            if (resendCountdown === 0) {
              clearInterval(resendTimer);
              resendCountdown = resendSeconds;
              $resendTxt.hide();
              $resendLink.show();
            }
          }, 1000);
        } else {
          Toast.fire({
            type: 'error',
            title: 'Não foi possível verificar o e-mail.',
          });
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        hideLoader();
        sending = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível verificar o e-mail.',
        });
      });
    }

    // Obtém o código informado
    function getVerificationCode() {
      let code = '';
      $('.verification-code input').each(function () {
        code += $(this).val();
      });
      if (code.length === 5) {
        return code;
      }
      return false;
    }

    // Valida o codigo
    function validateCode() {
      if (sending) {
        return false;
      }
      const code = getVerificationCode();
      if (!code) {
        Toast.fire({
          type: 'warning',
          title: 'Informe o código de verificação completo.',
        });
        return false;
      }
      const data = {
        acao: 'verifica_codigo',
        code: code,
        email: $campoEmail.val().trim(),
      };
      showLoader();
      sending = true;
      $.getJSON(urlVerifica, data, function (result) {
        console.log(result);
        sending = false;
        if (result && result.status === 'success') {
          hideLoader();
          registerLogin();
        } else {
          hideLoader();
          $('.verification-code input').val('');
          setTimeout(() => {
            $('.verification-code input').first().focus();
          }, 100);
          Toast.fire({
            type: 'error',
            title: 'Código de verificação inválido!',
          });
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        hideLoader();
        sending = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível validar o código.',
        });
      });
    }

    // Realiza o login
    function registerLogin() {
      if (!sending) {
        // Verifica se tem recaptcha e adiciona o token
        if (
          $form.hasClass('enable-recaptcha') &&
          typeof grecaptcha !== 'undefined' &&
          typeof recaptchaKey !== 'undefined'
        ) {
          recaptchaGenerateToken(
            $form,
            function () {
              const obj = $form[0];
              const dados = new FormData(obj);
              hideVerification();
              beforeSend();
              $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: dados,
                contentType: false,
                processData: false,
                dataType: 'json',
                success: function (data) {
                  successSend(data);
                },
                error: function (xhr, type, exception) {
                  errorSend(xhr);
                },
              });
            },
            resetSend,
          );
        }
      } else {
        console.log('sending true...');
      }
    }

    // Enquanto o formulário está sendo processado
    function beforeSend() {
      sending = true;
      $btnSubmit.prop('disabled', true);
      $btnSubmit.html('<div class="btn-spinner"></div> Aguarde');
    }

    // Reseta o formulário
    function resetSend() {
      $btnSubmit.prop('disabled', false);
      $btnSubmit.html(btnSubmitTxt);
      sending = false;
    }

    // Retorn do formulário
    function successSend(data) {
      console.log(data);
      if (data.status === 'success') {
        Toast.fire({
          type: 'success',
          title: 'Login realizado com sucesso.',
        });
        setTimeout(() => {
          location.href = $('#retorno_success').val();
        }, 1000);
      } else if (data.status == 'forbidden') {
        resetSend();
        Toast.fire({
          type: 'error',
          title: 'Acesso não permitido.',
        });
      } else if (data.status == 'verification_required') {
        resetSend();
        sendVerification();
      } else {
        resetSend();
        Toast.fire({
          type: 'error',
          title: data.message,
        });
      }
    }

    // Erro do envio
    function errorSend(resp) {
      console.log(resp);
      resetSend();
      Toast.fire({
        type: 'error',
        title: 'Não foi possível processar a solicitação.',
      });
    }
  }
})(jQuery);
